
import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { ILocation, IProjectExploreFilters } from '@/types/projects'
import { TGenericObject } from '@/types/base'
import { API_URLS } from '@/utils/helpers'
@Component
export default class MapMixin extends Vue {
  googleMapsAccepted = false
  showMap = true
  pageSize = 25
  currentPage = 1
  projectLocations: ILocation[] = []
  projectFilters: IProjectExploreFilters = {
    searchString: '',
    hideFullyFunded: true,
    hideExpired: true,
    categories: [],
    sortOrder: null,
    cmsFilter: null
  }

  mapBounds = {
    lat: {
      min: null,
      max: null
    },
    lng: {
      min: null,
      max: null
    }
  }

  created (): void {
    this.loadData()
    if (this.$cookies.get('cookie_rule_detail')?.includes('google-maps')) {
      this.googleMapsAccepted = true
    }
  }

  async loadData (): Promise<void> {
    this.fetchLocations()
  }

  exploreUrl (rootUrl: string, includeBounds = true, paginated = true): string {
    const filtersParams: TGenericObject = {}

    if (this.projectFilters.searchString) filtersParams.search = this.projectFilters.searchString
    if (this.projectFilters.hideExpired) filtersParams.hide_expired = this.projectFilters.hideExpired
    if (this.projectFilters.hideFullyFunded) filtersParams.hide_fully_funded = this.projectFilters.hideFullyFunded
    if (this.projectFilters.categories.length) filtersParams.categories = this.projectFilters.categories.join(',')
    if (this.projectFilters.sortOrder) filtersParams.ordering = this.projectFilters.sortOrder

    if (includeBounds) {
      if (this.mapBounds.lat.min) filtersParams.latitude_min = this.mapBounds.lat.min
      if (this.mapBounds.lat.max) filtersParams.latitude_max = this.mapBounds.lat.max
      if (this.mapBounds.lng.min) filtersParams.longitude_min = this.mapBounds.lng.min
      if (this.mapBounds.lng.max) filtersParams.longitude_max = this.mapBounds.lng.max
    }

    const filterKeys = Object.keys(filtersParams)
    const urlFilterParams = filterKeys.length ? `&${filterKeys.map(key => `${key}=${filtersParams[key]}`).join('&')}` : ''
    return paginated ? `${rootUrl}?page_size=${this.pageSize}&page=${this.currentPage}${urlFilterParams}` : `${rootUrl}?${urlFilterParams}`
  }

  get exploreLocationsUrl (): string {
    return this.exploreUrl(API_URLS.EXPLORE.PROJECTS.LOCATIONS, false, false)
  }

  async fetchLocations (): Promise<void> {
    await axios.get(this.exploreLocationsUrl).then(response => {
      this.projectLocations = response.data
    })
  }

  get minMaxBounds (): google.maps.LatLngBoundsLiteral | undefined {
    if (this.projectLocations.length) {
      return {
        north: Math.max(...this.projectLocations.map(location => location.latitude)),
        east: Math.max(...this.projectLocations.map(location => location.longitude)),
        south: Math.min(...this.projectLocations.map(location => location.latitude)),
        west: Math.min(...this.projectLocations.map(location => location.longitude))
      }
    }
  }

  onBoundsChanged (bounds: google.maps.LatLngBounds | undefined): void {
    if (bounds) {
      const northEast = bounds.getNorthEast()
      const southWest = bounds.getSouthWest()
      this.mapBounds.lat.min = southWest.lat()
      this.mapBounds.lat.max = northEast.lat() < 0 ? 180 : northEast.lat()
      this.mapBounds.lng.min = southWest.lng()
      this.mapBounds.lng.max = northEast.lng() < 0 ? 180 : northEast.lng()
    }
  }
}
